import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { NegocioPrioridadeSelectComponent } from './negocio-prioridade-select.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        NegocioPrioridadeSelectComponent
    ],
    exports: [
        NegocioPrioridadeSelectComponent
    ]
})
export class NegocioPrioridadeSelectModule { }
